export const orderDirections = Object.freeze({
  ASCENDING: 'asc',
  DESCENDING: 'desc',
});
